<template>
  <SecondaryButton
    x-small
    btnClass="mr-2 rounded"
    icon="mdi-eye"
    iconClass=""
    @click="viewOrderDetails()"
  >
  </SecondaryButton>
</template>

<script>
export default {
  methods: {
    async viewOrderDetails() {
      this.params.context.parentComponent.getOrderDetails(this.params.data);
    },
  },
};
</script>

<style>
</style>